<template>
  <v-card color="#faf9ff" outlined class="mb-3 ml-9">
    <v-card-text>
      <div class="d-flex justify-space-between align-center mb-3">
        <div class="text-body-2">{{ action.summary }}</div>
        <div class="text-caption text-medium-emphasis">{{ appliedCount }} de {{ action.changes.length }} aplicadas</div>
      </div>

      <AgentDiffCard
        v-for="change in action.changes"
        :key="change.id"
        :change="change"
        @decide="$emit('decide', { change, decision: $event })"
      />

      <div v-if="hasMultiplePending" class="d-flex">
        <v-btn small outlined class="mr-2" @click="decideAll('rejected')">Recusar todas</v-btn>
        <v-btn small color="primary" outlined @click="decideAll('accepted')">Aceitar todas</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import AgentDiffCard from '../ui/AgentDiffCard.vue'

export default {
  name: 'AgentProposalMessage',
  components: { AgentDiffCard },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  computed: {
    appliedCount() {
      return this.action.changes.filter((change) => change.status === 'accepted').length
    },
    hasMultiplePending() {
      return this.action.changes.filter((change) => change.status === 'pending').length > 1
    },
  },
  methods: {
    decideAll(decision) {
      this.action.changes
        .filter((change) => change.status === 'pending')
        .forEach((change) => this.$emit('decide', { change, decision }))
    },
  },
}
</script>
